import React, { Suspense } from 'react';

const DelayedSDKImportCompleteStep =
  React.lazy(() => import(/* webpackChunkName: "sdk-import-complete-step.async" */ './sdk-import-complete-step')
    .then(({ SDKImportCompleteStepWithI18n }) => ({
      default: SDKImportCompleteStepWithI18n,
    })));

export const DelayedSDKImportCompleteStepWithI18n = () => (
  <Suspense fallback={null}>
    <DelayedSDKImportCompleteStep />
  </Suspense>
);
